import { states, transitions } from '../transactions/transactionProcessBooking';

export const DEFAULT_CONSTANTS = {
  BANNER_IMAGE_CATEGORIES: '/static/seo/hub-city-default.webp',
  CURRENCY_SYMBOL: '$',
  LINE_ITEM_SECURITY_DEPOSIT: 'line-item/security-deposit',
};

export const PRICE_KEYS = ['perDayPrice', 'perWeekPrice', 'perMonthPrice'];

export const EXTEND_BOOKING_STATUS = {
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  REQUESTED: 'requested',
};

export const ENUMS = {
  TRAILER_TYPE: 'trailerType',
};
export const PRICE_CODES = {
  DAY: 'day',
  PER_WEEK: 'perWeek',
  PER_MONTH: 'perMonth',
};

export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const DashboadPageNavOption = Object.freeze({
  TRANSACTIONS_DETAILS: 'transactions-details',
});

export const Environment = Object.freeze({
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
});

export const TransactionDetailsPanelOption = Object.freeze({
  TRANSACTION_ID: 'transactionId',
  LISTING_TITLE: 'listingTitle',
  GUEST_NAME: 'guestName',
  RESERVATION_DATE: 'reservationDate',
  NIGHTS_BOOKED: 'nightsBooked',
  CUSTOMER_PAID_AMOUNT: 'customerPaidAmount',
  LAST_TRANSITION: 'lastTransition',
  TRANSITIONS: 'transitions',
  PAYOUT_DATE: 'payoutDate',
});

export const transitionAndStatusArr = [
  { lastTransition: 'transition/accept', label: 'Accepted' },
  { lastTransition: 'transition/decline', label: 'Declined' },
  { lastTransition: 'transition/expire', label: 'Expired' },
  { lastTransition: 'transition/cancel', label: 'Canceled' },
  { lastTransition: 'transition/complete', label: 'Completed' },
  { lastTransition: 'transition/refund-security-deposit', label: 'Refund security deposit' },
  { lastTransition: 'transition/request-damage-claim', label: 'Request damage claim' },
  { lastTransition: 'transition/accept-damage-claim', label: 'Accept damage claim' },
  {
    lastTransition: 'transition/decline-damage-claim-full-refund-to-customer',
    label: 'Decline damage claim',
  },
];

export const statesArr = [
  { value: 'inquiry', label: 'Inquiry' },
  { value: 'preauthorized', label: 'Requested bookings' },
  { value: 'declined', label: 'Declined' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'expired', label: 'Expired' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'provider-signed', label: 'Provider Signed' },
  { value: 'customer-signed', label: 'Customer Signed' },
  { value: 'booking-extended', label: 'Booking Extended' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'refund', label: 'Refund' },
  { value: 'refund-requested', label: 'Refund Requested' },
  { value: 'reviewed', label: 'Reviewed' },
];

export const dashBoardStateTransitionMap = {
  [states.INQUIRY]: {
    t1: transitions.INQUIRE,
  },
  [states.PREAUTHORIZED]: {
    t1: transitions.CONFIRM_PAYMENT,
  },
  [states.DECLINED]: {
    t1: transitions.DECLINE,
    t2: transitions.DECLINE_BY_CUSTOMER,
    t3: transitions.OPERATOR_DECLINE,
  },
  [states.ACCEPTED]: {
    t1: transitions.ACCEPT,
    t2: transitions.OPERATOR_ACCEPT,
  },
  [states.EXPIRED]: {
    t1: transitions.EXPIRE,
  },
  [states.CANCELED]: {
    t1: transitions.CANCEL_BY_CUSTOMER_AFTER_ACCEPTED,
    t2: transitions.CANCEL_BY_PROVIDER_AFTER_ACCEPTED,
    t3: transitions.CANCEL,
    t4: transitions.CANCEL_BY_CUSTOMER_AFTER_PROVIDER_SINGED,
    t5: transitions.CANCEL_BY_PROVIDER_AFTER_PROVIDER_SINGED,
    t6: transitions.CANCEL_BY_CUSTOMER_AFTER_CUSTOMER_SINGED,
    t7: transitions.CANCEL_BY_PROVIDER_AFTER_CUSTOMER_SINGED,
  },
  [states.PROVIDER_SIGNED]: {
    t1: transitions.SIGNED_BY_PROVIDER,
  },
  [states.CUSTOMER_SIGNED]: {
    t1: transitions.SIGNED_BY_CUSTOMER,
  },
  [states.DELIVERED]: {
    t1: transitions.COMPLETE,
    t2: transitions.OPERATOR_COMPLETE,
  },
  [states.BOOKING_EXTENDED]: {
    t1: transitions.EXTEND_BOOKING,
  },
  [states.REFUND]: {
    t1: transitions.REFUND_SECURITY_DEPOSIT,
    t2: transitions.DECLINE_DAMAGE_CLAIM_FULL_REFUND,
    t2: transitions.ACCEPT_DAMAGE_CLAIM,
    t2: transitions.AUTO_REFUND_FULL_SECURITY_DEPOSIT,
  },
  [states.REFUND_REQUESTED]: {
    t1: transitions.REQUEST_DAMAGE_CLAIM,
  },
  [states.REVIEWED]: {
    t1: transitions.REVIEW_2_BY_PROVIDER,
    t2: transitions.EXPIRE_PROVIDER_REVIEW_PERIOD,
    t3: transitions.REVIEW_2_BY_CUSTOMER,
    t4: transitions.EXPIRE_CUSTOMER_REVIEW_PERIOD,
  },
};

export const PLAN_FEATURES = {
  free: [
    'Public listing visible to every renter searching your area.',
    'Messaging through the BigLoads platform.',
    'No phone, email, website, or social links shown.',
    'No priority placement in search.',
    'No verified badge.',
  ],

  haulStar: [
    'Business phone number displayed.',
    'Business email displayed.',
    'Website link displayed.',
    'Direct renter contact enabled.',
    'Business profile branding.',
    'Social media links allowed on listings.',
    'Contact information allowed on listing images.',
    'Import your Google reviews to your listings and profile.',
    'Haul Star Verified badge.',
  ],
};

// Feature bullets marked as "locked" on the Free tier (rendered with a lock icon).
export const FREE_LOCKED_FEATURE_INDICES = [2, 3, 4];

export const UI_PLANS_BASE = [
  {
    tierKey: 'freePlan',
    label: 'Free Plan',
    description: 'Free messaging and public listing visibility on the BigLoads platform.',
    features: PLAN_FEATURES.free,
    popular: false,
    priceLabel: '$0/month',
    productId: 'prod_TRFV1qasvsyrNZ',
    stripePrice: 'price_1SUN0cB5WpxagAVtpXk4dvBW',
    currency: 'usd',
  },
  {
    tierKey: 'haulStar',
    label: 'Haul Star',
    description:
      'For owners who want renters blowing up their phone, email, website, and socials, not waiting on a message that sits unread.',
    features: PLAN_FEATURES.haulStar,
    popular: true,
    priceLabel: '$30/month',
    perDayNote: 'Just $1 a day to grow your business.',
    trialNote: 'No contract. Cancel anytime.',
    // Haul Star $30/mo (no trial). Product + price created in Stripe 2026-07-23.
    productId: 'prod_UwGAw4tJxOrMhH',
    stripePrice: 'price_1TwNdhB5WpxagAVtozudHHsp',
    currency: 'usd',
  },
];

export const SUBSCRIPTION_MODAL_STEPS = Object.freeze({
  STEP_1: 1,
  STEP_2: 2,
  STEP_3: 3,
});

// These MUST match the exact Stripe PRODUCT names, because the webhook
// (syncSubscriptionToProfile) writes protectedData.subscriptionProductName =
// <stripe product.name>, and the frontend membership/badge checks compare
// against these constants. The current Stripe products are named "Haul Star"
// and "Free" (NOT "... Plan"). Mismatch => a paying member is never recognized
// (menu keeps showing "Get Haul Star", listing badges never unlock).
export const SUBSCRIPTION_PLAN_NAMES = Object.freeze({
  FREE: 'Free',
  HAUL_STAR: 'Haul Star',
  BIG_RIG: 'Big Rig',
});

export const SOCIAL_PLATFORM_OPTIONS = [
  { key: '', label: 'Select a platform', value: '' },
  { key: 'instagram', label: 'Instagram', value: 'instagram' },
  { key: 'facebook', label: 'Facebook', value: 'facebook' },
  { key: 'tiktok', label: 'TikTok', value: 'tiktok' },
  { key: 'youtube', label: 'YouTube', value: 'youtube' },
  { key: 'linkedin', label: 'LinkedIn', value: 'linkedin' },
  { key: 'twitter', label: 'Twitter', value: 'twitter' },
  { key: 'pinterest', label: 'Pinterest', value: 'pinterest' },
  { key: 'snapchat', label: 'Snapchat', value: 'snapchat' },
  { key: 'website', label: 'Website', value: 'website' },
];
